(function() {
    'use strict';

    angular.module('file')
        .controller('FileCreateController', FileCreateController);

    FileCreateController.$inject = ['$state', 'fileDataSrvc', 'notificationSrvc', 'fileMessagesConst', 'errorNotificationSrvc'];

    function FileCreateController($state, fileDataSrvc, notificationSrvc, fileMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            file: [],
            nonFieldErrors: []
        };
        self.fileData = {
            name_pl: '',
            name_en: '',
            name_de: '',
            name_cpde: '',
            name_cpen: '',
            file: undefined
        };

        self.createFile = createFile;
        self.cleanErrors = cleanErrors;

        function createFile() {
            fileDataSrvc.create(
                self.fileData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", fileMessagesConst.add);
                    $state.go('layout.file.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
